import { useRef, useEffect } from 'react';
import SideBar from 'components/SideBar/index';
import ColorPaletteSelector from './ColorPaletteSelector';
import LogoSelector from './LogoSelector';
import ManifestationEditor from './ManifestationEditor';
import { useAppContext } from 'lib/state/TextProvider';

const Design = () => {
  const { state } = useAppContext();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [containerRef.current]);

  return (
      <div
        className="default relative h-screen bg-repeat bg-palette-5 overflow-hidden"
      >
        <div className="h-screen w-screen flex flex-row">
          <SideBar/>
          <div className="flex-1 flex flex-col h-full w-full">
            <div className="flex justify-center items-center w-full text-palette-2">
              {state.userProfile?.manifestation}
            </div>
            <div className="flex-1 p-2 overflow-auto">
              <div
                ref={containerRef}
                className="h-full w-full rounded-lg border-2 border-palette-3 bg-palette-4 overflow-auto"
              >
                <div className="m-10">
                  <ManifestationEditor />
                </div>
                <div className="m-10">
                  <ColorPaletteSelector />
                </div>
                <div className="m-10">
                  <LogoSelector />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default Design;
